import {
	AfterViewInit,
	Component,
	HostListener,
	Input,
	OnDestroy
}                        from '@angular/core';
import { BaseComponent } from '@app/core/bases/base-component/base.component';

@Component( {
	selector: 'app-sticky-base',
	template: '<div></div>'
} )
export class StickyBaseComponent extends BaseComponent implements AfterViewInit, OnDestroy {

	private scrollableContentElement: Element;
	private stickyContentElement: HTMLDivElement;
	private referenceStickyContentElement: HTMLDivElement;

	@Input() backgroundMode: 'transparent' | 'visible' | 'stickyVisible' = 'visible';
	@Input() referenceStickyContentId: string;
	@Input() stickyContentId = 'stickyContent';
	@Input() scrollableContentId = 'scrollableContent';
	@Input() referenceStickyContentElementTopOffset = 0;
	@Input() disableContentStickiness = false;

	referenceStickyContentElementOffset = 0;
	createLinkSticked = false;

	private isSticky(): void {
		this.getDomElements();
		if ( this.referenceStickyContentElement ) {
			this.calculateReferenceStickyContentElementOffset();
		}

		if ( this.stickyContentElement && this.scrollableContentElement ) {
			const isStickyPoint = this.stickyContentElement.clientHeight + this.stickyContentElement.getBoundingClientRect().top;
			this.createLinkSticked = isStickyPoint > this.scrollableContentElement?.getBoundingClientRect().top;
		}

		if ( window.scrollY === 0 ) {
			this.createLinkSticked = false;
		}
	}

	private calculateReferenceStickyContentElementOffset(): void {
		if ( this.referenceStickyContentElement ) {
			this.referenceStickyContentElementOffset =
				this.referenceStickyContentElement.clientHeight + this.referenceStickyContentElement.getBoundingClientRect().top;
		}
	}

	private getDomElements(): void {
		if ( this.disableContentStickiness ) { return; }

		this.stickyContentElement = document.querySelector( `#${ this.stickyContentId }` );
		this.scrollableContentElement = document.querySelector( `#${ this.scrollableContentId }` );
		this.referenceStickyContentElement = document.querySelector( `#${ this.referenceStickyContentId }` );
	}

	private init(): void {
		if ( this.disableContentStickiness ) { return; }

		const timeout = setTimeout( () => {
			clearTimeout( timeout );
			this.calculateReferenceStickyContentElementOffset();
		}, 0 );
	}

	@HostListener( 'window:scroll', [] )
	onScroll(): void {
		if ( this.disableContentStickiness ) { return; }
		this.isSticky();
	}

	ngAfterViewInit(): void {
		this.getDomElements();

		if (
			this.stickyContentElement && this.scrollableContentElement ||
			this.stickyContentElement && this.scrollableContentElement && this.referenceStickyContentElement
		) {
			this.init();
		}
	}
}
